import React from 'react';
import { IconTooltip } from 'utils/components/IconTooltip';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export function OrderVolumeProfileHelpText() {
    return (
        <>
            <div>
                This widget shows the volume profile for the selected order.
            </div>
            <div>
                The data is grouped into time bins which can be changed via the
                widget&apos;s configuration tool <Icon name="cog" />.
            </div>
            <div>
                The start time is based on the selected order. The same for the
                end time, if available (otherwise it will default to EOD). You
                can edit the start and end time by clicking on{' '}
                <Icon name="edit" /> and reset back to the defaults by clicking{' '}
                <Icon name="trash" />.
            </div>
            <div>
                In the widget configuration <Icon name="cog" /> you can set:
                <br />
                <br />
                <div style={{ paddingLeft: '5px' }}>
                    <div style={{ fontWeight: '700' }}>Include Auctions</div>
                    <div style={{ paddingLeft: '10px' }}>
                        Whether to include open/close auction volumes
                    </div>
                </div>
                <div style={{ paddingLeft: '5px', marginTop: '5px' }}>
                    <div style={{ fontWeight: '700' }}>
                        Include continuous trading sessions
                    </div>
                    <div style={{ paddingLeft: '10px' }}>
                        Whether to include only continuous trading sessions
                        (e.g. AM/PM/REG)
                    </div>
                </div>
                <div style={{ paddingLeft: '5px', marginTop: '5px' }}>
                    <div style={{ fontWeight: '700' }}>
                        Use special day trading curve
                    </div>
                    <div style={{ paddingLeft: '10px' }}>
                        Whether to use special day trading curve
                        (CUSTOM_INSTINET NDS profile type)
                    </div>
                </div>
            </div>
            <div>The grid supports sorting and has a column picker</div>
        </>
    );
}

export default function OrderVolumeProfileHelp() {
    return (
        <div style={{ marginLeft: '5px', marginTop: '-1px' }}>
            <IconTooltip>
                <OrderVolumeProfileHelpText />
            </IconTooltip>
        </div>
    );
}
